module.exports = __webpack_public_path__ + "static/media/DougTV.b0456bc0.gif";